export default __webpack_public_path__ + "static/media/CFD169.c57a3417.jpg";